/**
 * Copyright 2019-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2021 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { StacklightLamp } from '@umati/dashboard-types';
import React, { useState } from 'react';
import URLs from '../../../utilities/URLs';
import { staticBucketReachable } from 'redux/selectors';
import { connect } from 'react-redux';
import { IStore } from 'redux/storeType';

function DetailGallery(props: {
  lamps?: StacklightLamp[];
  machineId: string;
  colors?: string[];
  machineType?: string;
  defaultImagePathClassifier?: string;
  imagePath?: string;
  staticBucketReachable: boolean;
}) {
  const stackLights: React.ReactElement[] = [];
  const imagePath = URLs.getMachineImageBucket(props.imagePath, props.staticBucketReachable);
  const fallbackPath = URLs.getMachineImageBucketDefault(
    props.machineType,
    props.defaultImagePathClassifier,
    props.staticBucketReachable,
  );
  const [imagePathFailedOn, setImagePathFailedOn] = useState('');

  if (props.lamps) {
    const lamps = props.lamps.sort((a: StacklightLamp, b: StacklightLamp) => {
      return b.NumberInList - a.NumberInList;
    });

    for (const lamp of lamps) {
      const signalOn = lamp.SignalOn ? 'on' : 'off';
      if (lamp.SignalColor.startsWith('#')) {
        stackLights.push(
          <div
            className="stacklight-item"
            key={lamp.NumberInList}
            style={{ backgroundColor: lamp.SignalColor }}
            data-signal-on={signalOn}
          />,
        );
      } else {
        stackLights.push(
          <div
            className="stacklight-item"
            key={lamp.NumberInList}
            data-color={lamp.SignalColor}
            data-signal-on={signalOn}
          />,
        );
      }
    }
  }

  const shouldRetry = imagePathFailedOn !== imagePath;

  return (
    <div className="gallery mb-3 mb-lg-5">
      <div className="container">
        <img
          src={shouldRetry ? imagePath : fallbackPath}
          alt=""
          onError={() => {
            setImagePathFailedOn(imagePath);
          }}
        />
        {!shouldRetry && props.imagePath && <div className="text-mid">404</div>}
      </div>
      {props.lamps && <div className="stacklight">{stackLights}</div>}
    </div>
  );
}

const mapStateToProps = (state: IStore) => {
  return {
    staticBucketReachable: staticBucketReachable(state) || false,
  };
};

export default connect(mapStateToProps)(DetailGallery);
